import { readShowReportCardMenuFromRawUser } from '@/features/report-cards/readShowReportCardMenu';
import { useAuthStore } from '@/store/authStore';

/** Sidebar / route guard for Report Cards (iOS `showReportCardMenu` parity). */
export function useShowReportCardMenu(): boolean {
  const rawUser = useAuthStore((state) => state.rawUser);
  return readShowReportCardMenuFromRawUser(rawUser);
}
